export default __webpack_public_path__ + "static/media/ETH-symbol.2972fcac.svg";